import React from 'react';
import SupportEmailLink from '@/components/common/SupportEmailLink';
import translate from '@/lib/intl/translate';

type IntegrationHelpPromptProps = {
  noInstructions?: boolean;
};

function IntegrationHelpPrompt({
  noInstructions = false,
}: IntegrationHelpPromptProps) {
  return (
    <div className="rounded-lg border border-grey-300 bg-grey-100 p-3 text-center type-body3 md:type-body1">
      {translate('INTEGRATIONS_NEED_HELP', {
        noInstructions,
        link: <SupportEmailLink />,
      })}
    </div>
  );
}

export default IntegrationHelpPrompt;
